import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { computed, defineComponent, ref, reactive, toRefs } from '@vue/composition-api';
import set from 'lodash/set';
import { range, toLocaleString } from '@/common/util';
import { appName } from '@/common/const';
import lockIcon from './images/lock.png';
import coinIcon from './images/coin.png';
import coinIconSnack from './images/coin-snack.png';
import coinIconMe from './images/coin-me.png';
var coins = {
  pro: coinIcon,
  me: coinIconMe,
  snack: coinIconSnack
};
export default defineComponent({
  props: {
    pointList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    positionList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentGold: {
      type: Number,
      default: 0
    },
    moreText: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    isReachMax: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var state = reactive({
      isRtl: ctx.root.$isRtl
    });
    var contentElement = ref(null);
    var barElement = ref(null); // 将下一个阈值滚动到中间

    var scrollToMiddle = function scrollToMiddle(points, contentWidth, maxWidth) {
      setTimeout(function () {
        var nextPointGap = 0;
        points.forEach(function (point, index) {
          if (nextPointGap > 0) {
            return;
          }

          if (point.value >= props.currentGold) {
            nextPointGap = point.gap;
          } else if (index + 1 === points.length) {
            nextPointGap = maxWidth;
          }
        });
        var scrollGap = nextPointGap < contentWidth / 2 ? 0 : nextPointGap - contentWidth / 2 + 12;
        set(contentElement, 'value.scrollLeft', state.isRtl ? -scrollGap : scrollGap);
      }, 60);
    };

    var getLerpInFakeNumber = function getLerpInFakeNumber(currentGold) {
      var pointList = props.pointList,
          positionList = props.positionList; // 找到目标区间

      var targetRange = []; // 找到定位数组的区间

      var posRange = [];
      var index = 0;

      if (currentGold === 0) {
        targetRange = pointList.slice(0, 2);
      } else if (currentGold > pointList[pointList.length - 1]) {
        targetRange = pointList.slice(pointList.length - 2);
        index = pointList.length - 2;
      } else {
        var targetIndex = 0;

        for (var i = 0; i < pointList.length; i++) {
          if (currentGold <= pointList[i]) {
            targetIndex = i;
            break;
          }
        }

        targetRange = pointList.slice(targetIndex - 1, targetIndex + 1);
        index = targetIndex - 1;
      }

      posRange = positionList.slice(index, index + 2);
      return range(targetRange[0], targetRange[1], posRange[0], posRange[1], currentGold);
    };

    var formatThousand = function formatThousand(value) {
      return toLocaleString(Number(value));
    };

    var iconUrl = computed(function () {
      return props.source === 'taskCenter' ? coins[appName] || coinIcon : lockIcon;
    });
    var positionedPoint = computed(function () {
      var _contentElement$value, _contentElement$value2;

      if (props.positionList.length === 0) {
        return [];
      } // @ts-ignore todo: contentElement 类型添加


      var contentWidth = (_contentElement$value = contentElement === null || contentElement === void 0 ? void 0 : (_contentElement$value2 = contentElement.value) === null || _contentElement$value2 === void 0 ? void 0 : _contentElement$value2.offsetWidth) !== null && _contentElement$value !== void 0 ? _contentElement$value : '0';
      var valueAndWidthRatio = 1;
      var maxValue = props.positionList[props.positionList.length - 1];
      var maxWidth = (maxValue / valueAndWidthRatio < contentWidth ? contentWidth : maxValue / valueAndWidthRatio) - 25;
      var points = props.positionList.map(function (point, index) {
        return {
          value: props.pointList[index],
          gap: range(0, maxValue, 0, maxWidth, point)
        };
      });
      scrollToMiddle(points, contentWidth, maxWidth);
      return {
        points: points,
        currentWidth: range(0, maxValue, 0, maxWidth, getLerpInFakeNumber(props.currentGold)),
        maxWidth: maxWidth
      };
    });
    return _objectSpread(_objectSpread({}, toRefs(state)), {}, {
      barElement: barElement,
      contentElement: contentElement,
      positionedPoint: positionedPoint,
      iconUrl: iconUrl,
      formatThousand: formatThousand
    });
  }
});